import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['justselect', 'justselectList']

  openList() {
    this.justselectListTarget.classList.toggle('d-block')
  }
}